import { useEffect, useRef } from 'react';
import SuperAdminIcon from '../layout/SuperAdminIcon';
import { redactAdminRecord } from './AdminRecordTable';

const FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

const DetailDrawer = ({ open, title, eyebrow = 'Details', onClose, children, developerData }) => {
  const panelRef = useRef(null);
  const closeRef = useRef(null);
  const restoreRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    restoreRef.current = document.activeElement;
    closeRef.current?.focus();
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
      if (event.key !== 'Tab') return;
      const focusable = [...(panelRef.current?.querySelectorAll(FOCUSABLE) || [])];
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => { document.removeEventListener('keydown', handleKeyDown); restoreRef.current?.focus?.(); };
  }, [onClose, open]);
  if (!open) return null;
  return <div className="sa-drawer-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}><aside ref={panelRef} className="sa-drawer" role="dialog" aria-modal="true" aria-labelledby="sa-detail-drawer-title"><header><div><span>{eyebrow}</span><h2 id="sa-detail-drawer-title">{title}</h2></div><button ref={closeRef} className="sa-icon-button" type="button" onClick={onClose} aria-label="Close details"><SuperAdminIcon name="close" /></button></header><div className="sa-drawer__body">{children}{developerData ? <details className="sa-developer-details"><summary>Developer details</summary><pre>{JSON.stringify(redactAdminRecord(developerData), null, 2)}</pre></details> : null}</div></aside></div>;
};

export default DetailDrawer;
